const contactDetails = [
  { icon: "ri-map-pin-2-line", label: "Address", value: "Glavni trg 14" },
  { icon: "ri-building-2-line", label: "City", value: "Ljutomer" },
  { icon: "ri-mail-open-line", label: "Zip", value: "9240" },
  { icon: "ri-earth-line", label: "Country", value: "Slovenia" },
  { icon: "ri-mail-line", label: "Email", value: "help@linijedoo.com" },
  { icon: "ri-phone-line", label: "Number", value: "+1 5186327064" },
];

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Features", href: "#features" },
  { label: "Contact", href: "#contact" },
];

export default function ContactSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="contact" className="bg-[#F8FAF9] py-28">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-teal-600 text-xs font-bold tracking-[0.3em] uppercase block mb-4">Contact</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A0F1C] leading-tight mb-6">
            Get in Touch
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
            Have a question about our iOS apps or need support? We&apos;re here to help.
          </p>
        </div>

        {/* Contact cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
          {contactDetails.map((item) => (
            <div
              key={item.label}
              className="bg-white border border-gray-100 rounded-2xl px-6 py-6 flex items-start gap-4 hover:-translate-y-0.5 transition-transform duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-teal-50 text-teal-600 shrink-0">
                <i className={`${item.icon} text-xl`} />
              </div>
              <div>
                <div className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-1">{item.label}</div>
                <div className="text-[#0A0F1C] font-semibold text-base">{item.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Map-like decorative address block */}
        <div className="rounded-3xl bg-[#080C14] overflow-hidden grid grid-cols-1 lg:grid-cols-2">
          {/* Left */}
          <div className="p-10 md:p-14 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/de66027b-33b2-474e-82bc-b57a53ac7665.png"
                    alt="LINIJE d.o.o."
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="text-white font-bold text-xl">LINIJE d.o.o.</span>
              </div>
              <h3 className="text-white text-2xl md:text-3xl font-bold mb-4 leading-snug">
                Building iOS apps from the heart of Slovenia
              </h3>
              <p className="text-white/50 text-sm leading-relaxed">
                Our team is based in the beautiful town of Ljutomer, Slovenia. We combine European
                precision with a global vision to deliver iOS applications trusted by users worldwide.
              </p>
            </div>

            {/* Address block */}
            <div className="mt-10 border-t border-white/10 pt-8 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-teal-400">
                  <i className="ri-map-pin-line text-base" />
                </div>
                <span className="text-white/70 text-sm">
                  <strong className="text-white">Address:</strong> Glavni trg 14
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-teal-400">
                  <i className="ri-building-line text-base" />
                </div>
                <span className="text-white/70 text-sm">
                  <strong className="text-white">City:</strong> Ljutomer &nbsp;|&nbsp;
                  <strong className="text-white">Zip:</strong> 9240 &nbsp;|&nbsp;
                  <strong className="text-white">Country:</strong> Slovenia
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-teal-400">
                  <i className="ri-mail-line text-base" />
                </div>
                <span className="text-white/70 text-sm">
                  <strong className="text-white">Email:</strong> help@linijedoo.com
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-teal-400">
                  <i className="ri-phone-line text-base" />
                </div>
                <span className="text-white/70 text-sm">
                  <strong className="text-white">Number:</strong> +1 5186327064
                </span>
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="relative h-[400px] lg:h-auto">
            <img
              src="https://public.readdy.ai/ai/img_res/dd6ff321233a5de694937e378e54b6df.jpg"
              alt="Ljutomer, Slovenia"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#080C14]/60 to-transparent lg:block hidden" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/60 to-transparent lg:hidden" />
          </div>
        </div>

        {/* Footer bar */}
        <div className="mt-12 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-gray-200 pt-8">
          <div className="text-gray-400 text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} LINIJE d.o.o. All rights reserved.
          </div>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                className="text-gray-400 hover:text-teal-600 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
